import React from 'react';

const TabsOrientedThemePreview = ({ logoUrl }) => {
  return (
    <div id="themePreview"  className="d-flex flex-column theme-preview w-100 card-spacer-top">
      <div className="w-100 p-1 d-flex align-items-baseline">
        <div className="pb-1" style={{width: 30, height: 15, marginTop: "-.25rem" }}>
          <img src={logoUrl} className="logo-preview" />
        </div>

        <div className="ml-auto">
          <ul className="nav">
            <li className="nav-item mr-1">
              <div className="bg-primary mock" style={{width: 20, height: 6}} />
            </li>
            <li className="nav-item mr-1">
              <div className="bg-primary mock" style={{width: 20, height: 6}}/>
            </li>
            <li className="nav-item">
              <div className="bg-primary mock" style={{width: 20, height: 6}}/>
            </li>
          </ul>
        </div>
      </div>
      <nav className="w-100 main-navbar navbar navbar-expand-lg flex-wrap clearfix p-0">
        <ul className="navbar-nav" style={{fontSize: 8}}>
          <li className="nav-item p-0">
            <a className="nav-link active p-1 text-nowrap" href="#">
              Home
            </a>
          </li>
          <li className="nav-item">
            <a className="nav-link p-1 text-nowrap" href="#">
              Reviews
            </a>
          </li>
          <li className="nav-item">
            <a className="nav-link p-1 text-nowrap" href="#">
              Socials
            </a>
          </li>
        </ul>
      </nav>
      <div className="d-flex flex-row w-100 h-100">
        <div className="col-3 h-100 py-2 ">
          <h5 style={{fontSize: 8}}>My Account</h5>
          <div className="w-100 my-1 bg-primary" style={{ height: 10,backgroundColor:"var(--gray-300)" }} />
          <div className="w-100 my-2 bg-primary mock" style={{height: 5}} />
          <div className="w-100 my-2 bg-primary mock" style={{height: 5}} />
          <div className="w-100 my-2 bg-primary mock" style={{height: 5}} />
        </div>
        <div className="col-9 h-100 m-0 p-2">
          <h1 className="p-2" style={{fontSize: 12}}>Page Title</h1>
          <div className="row mb-3">
            <div className="col">
              <div className="card">
                <div className="card-header p-1" style={{fontSize: 8}}>&nbsp;</div>
                <div className="card-body">
                </div>
                <div className="card-footer d-flex justify-content-end p-1">
                  <div style={{fontSize: 3}} className="py-1 px-5 btn btn-sm btn-outline-secondary">
                    &nbsp;
                  </div>
                  <div style={{fontSize: 3}} className="py-1 px-5 btn btn-sm btn-secondary ml-1">
                    &nbsp;
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-6">
              <div className="card">
                <div className="card-header p-1" style={{fontSize: 8}}>&nbsp;</div>
                <div className="card-body">
                </div>
                <div className="card-footer d-flex justify-content-end p-1">
                  <div style={{fontSize: 3}} className="py-1 px-3 btn btn-sm btn-secondary">
                    &nbsp;
                  </div>
                </div>
              </div>
            </div>
            <div className="col-6">
              <div className="card">
                <div className="card-header p-1" style={{fontSize: 8}}>&nbsp;</div>
                <div className="card-body">
                </div>
                <div className="card-footer d-flex justify-content-end p-1">
                  <div style={{fontSize: 3}} className="py-1 px-3 btn btn-sm btn-secondary">
                    &nbsp;
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TabsOrientedThemePreview;
